import React from 'react';
import './AdvancedSearch.scss';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import * as actions from "store/actions/index";
import * as dt from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import * as aTypes from 'Flow2/components/AdvancedBox/AdvancedConfig/AdvancedTypes';
import Modal from "Flow2/components/AdvancedBox/AdvancedUI/Modal/Modal.js";
import Dropdown from "Flow2/components/AdvancedBox/AdvancedUI/Dropdown/Dropdown";
import DropdownWithInput from "Flow2/components/AdvancedBox/AdvancedUI/DropDownWithInput/DropDownWithInput";
import Button from "Flow2/components/AdvancedBox/AdvancedUI/Button/Button";
import CheckBox from "Flow2/components/AdvancedBox/AdvancedUI/CheckBox/CheckBox";
import MsgDialog from "Flow2/components/AdvancedBox/AdvancedUI/MsgDialog/MsgDialog";
import FormInput from "Flow2/components/AdvancedBox/AdvancedUI/FormInput/FormInput";
import { getConfigObjects, getSearchTypeData } from 'Flow2/components/AdvancedBox/AdvancedHelpers/ConfigHelper';
import { faPlus, faObjectGroup, faQuestion, faSave, faEdit, faCloudDownloadAlt }
    from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SortHelper from 'Flow2/components/AdvancedBox/AdvancedHelpers/SortHelper';
import { StockWindow } from "Flow2/components/TagsTree/TagTreeDynamic";
import { convertFields, uRefFi, stype, uFi } from 'Flow2/components/AdvancedBox/AdvancedHelpers/FieldHelper';
import PH from 'Flow2/util/MetadataPermissionHelper.js';
import * as Controls from 'Flow2/config/Controls';
import TypeFilter from 'Flow2/components/Filters/TypeFilter/TypeFilter';
import HelpDialog from 'Flow2/components/AdvancedBox/AdvancedUI/HelpDialog/HelpDialog';
import { CustomDateBox } from "Flow2/components/CustomCollections/CustomBox/CustomDataBox/CustomDataBox";

class AdvancedSearch extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            modalOpened: false,
            sourceFields: aTypes.SOURCE_OBJ,
            sourceElement: null,
            targetFields: [],
            advancedObj: {},
            errors: {},
            searchedList: [],
            userInputs: {},
            searchedListCur: null,
            stockOpened: false,
            helpCur: null
        }
    }

    fm = (id) => this.props.intl.formatMessage({ id });

    handleKeyDown = ({ key }) => {
        if (key === aTypes.SHIFT
            && !this.state.shiftArray /*(!this.state.shiftArray || this.state.shiftArray.length)*/) {
            this.setState({ shiftArray: [], shiftObj: {} });
        }
    }

    handleKeyUp = ({ key }) => {
        if (key === aTypes.SHIFT) {
            if (this.state.shiftArray) {
                if (this.state.shiftArray.length > 0) {
                    let newFields = this.getTargetFields();
                    this.setState({
                        targetFields: newFields,
                        advancedObj: {
                            ...this.state.advancedObj,
                            [`group_${Date.now()}`]: this.state.shiftArray
                        }
                    }, () => {
                        this.setState({ shiftArray: null, shiftObj: null });
                    });
                }
            } else {
                this.setState({ shiftArray: null, shiftObj: null });
            }
        }
    }

    checkWindowKey = () => {
        let handleKeyDown = this.handleKeyDown;
        let handleKeyUp = this.handleKeyUp;
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('keyup', handleKeyUp);
    }

    removeWindowKey = () => {
        let handleKeyDown = this.handleKeyDown;
        let handleKeyUp = this.handleKeyUp;
        window.removeEventListener('keydown', handleKeyDown);
        window.removeEventListener('keyup', handleKeyUp);
    }

    handleDragStart = (event) => {
        event.target.style.opacity = 0.5;
        this.state.sourceElement = event.target
        event.dataTransfer.effectAllowed = aTypes.MOVE;
    }

    handleDragOver = (event) => {
        event.preventDefault();
        event.dataTransfer.dropEffect = aTypes.MOVE;
    }

    handleDragEnter = () => { }
    handleDragLeave = () => { }

    handleDrop = (event) => {
        event.stopPropagation();
        try {
            let field = JSON.parse(this.state.sourceElement.dataset.item);
            let found = this.state.sourceFields.find(item => item.field == field);
            let newItem;
            if (found) {
                newItem = { ...found };
                newItem.id = `${Date.now()}`;
                if (found.params && found.params.profi_search && found.params.profi_search.connector) {

                }
            }
            if (this.state.targetFields.length > 0) {
                this.setState({
                    targetFields: [...this.state.targetFields,
                    { ...aTypes.CONNECTOR_OBJ, id: `${aTypes.CONN}${newItem.id}` }, newItem]
                });
            } else {
                this.setState({ targetFields: [newItem] });
            }

        } catch (e) {
            console.log("LOGS: handleDrop Err");
        }
    }

    handleDragEnd = (event) => {
        event.target.style.opacity = 1;
    }

    getConfig = () => {
        let config = getConfigObjects({
            configObj: this.props.config, configName: "clip", users: this.props.users,
            lg: this.props.lg, flexObjects: this.props.flexObjects
        });
        return config;
    }

    initData = () => {
        let lastSearch = this.props.flexObjects.lastSearch || lastSearch;
        this.initSearchListDD();
        // if (!this.props.flexObjects.flexTags || !this.props.flexObjects.flexTags.length) {
        //     this.props.getFlexTags();
        // }
        this.setState({ sourceFields: this.getConfig(), ...lastSearch });
    }

    initSearchListDD = () => {
        const { searchedList } = this.props.flexObjects;
        if (!searchedList || !searchedList.length) {
            const advancedsearchpresets = this.props.user.granting.udo.advancedsearchpresets;
            if (advancedsearchpresets && advancedsearchpresets.length) {
                this.setState({
                    searchedList: [
                        { ...aTypes.DD_SELECT },
                        ...advancedsearchpresets
                    ]
                });
                this.props.updateFlexObjects({ searchedList: [...advancedsearchpresets] });
            }
        } else {
            this.setState({ searchedList: [{ ...aTypes.DD_SELECT }, ...searchedList] });
        }
    }


    updateData = () => {
        this.updateSearchListDD();
        this.setState({ sourceFields: this.getConfig() });
    }

    updateSearchListDD = () => {
        if (this.props.flexObjects && this.props.flexObjects.searchedList) {
            this.setState({
                searchedList: [
                    { ...aTypes.DD_SELECT },
                    ... this.props.flexObjects.searchedList
                ]
            });
        }
    }

    getTargetFields = () => {
        let newFields = [];
        let isFirst = true;
        let curParents = null;
        this.state.targetFields.forEach(field => {
            let checkId = field.id;
            if (field.id.includes(aTypes.CONN) && !isFirst) {
                checkId = dt.subStringAfter(field.id, aTypes.CONN);
            }
            if (this.state.shiftObj[checkId]) {
                if (!isFirst) {
                    newFields.forEach(el => {
                        //if (el.id && el.id.includes(aTypes.PARENTS)) {
                        if (el.id && el.id == curParents) {
                            el.data.push(field);
                        }
                    })
                } else {
                    curParents = `${aTypes.PARENTS}${field.id}`;
                    newFields.push({
                        id: curParents,
                        type: "group", data: [field]
                    });
                    isFirst = false;
                }

            } else {
                newFields.push(field);
            }
        });
        return newFields;
    }

    closeModal = () => {
        this.setState({ modalOpened: false });
        this.props.onClose();
        //this.props.searchClosed();
    }

    handleTargetInput = ({ item }) => (e) => {
        const { userInputs } = this.state;
        const { value } = e.target;
        this.setState({ userInputs: { ...userInputs, [`${uFi(item)}`]: value } });
    }

    onInputBtnClick = ({ item }) => () => {
        this.setState({
            stockOpened: true,
            dynObj: {
                ...this.state.dynObj,
                curNameIds: [`${uRefFi(item)}`],
                curName: [`${uFi(item)}`]
            }
        });
    }

    onStockHandler = (values) => {
        const { userInputs, dynObj } = this.state;
        let value = "", keywords = "";
        if (values && values.tags && values.tags.length > 0) value = values.tags.join(";");
        if (values && values.keywords && values.keywords.length > 0) keywords = values.keywords.join(";");
        this.setState({
            userInputs:
            {
                ...userInputs, [dynObj.curNameIds]: value,
                [dynObj.curName]: keywords
            }
        });
    }

    onSortDDCk = ({ item }) => (el) => { }

    onDDCk = ({ item }) => (el) => {
        if (el.value) {
            const { advancedObj } = this.state;
            this.setState({ advancedObj: { ...advancedObj, [`${stype(item)}`]: el } });
        }
    }

    onTargetDDCk = ({ item }) => (el) => {
        const { userInputs, advancedObj } = this.state;
        let itemId = item.id;
        if (itemId && itemId.includes(`${aTypes.CONN}`)) {
            this.setState({ advancedObj: { ...advancedObj, [`${itemId}`]: el } });
        } else {
            this.setState({ userInputs: { ...userInputs, [`${uFi(item)}`]: el } });
        }
    }

    onDDSearchedList = (el) => {
        this.setState({
            targetFields: [...el.data] || [],
            userInputs: { ...el.userInputs },
            searchedListCur: el,
            advancedObj: { ...el.advancedObj }
        });
    }

    onDDSearchedListDelete = (el) => {
        let list = [];
        const { searchedList } = this.props.flexObjects;
        if (searchedList) {
            list = searchedList.filter(item => item.value !== el.value);
            if (this.state.searchedListCur && this.state.searchedListCur.value === el.value) {
                this.setState({ targetFields: [], searchedListCur: null });
            }
        }
        this.saveListData({ list });
    }

    onDeleteItem = ({ item }) => () => {
        let newFields = this.state.targetFields;
        newFields = newFields.filter(el => el.id !== item.id);
        newFields = newFields.filter(el => el.id !== `${aTypes.CONN}${item.id}`);
        newFields = newFields.filter(el => {
            let connId = dt.subStringAfter(el.id, aTypes.CONN);
            let parentId = dt.subStringAfter(item.id, aTypes.PARENTS);
            if (connId && parentId && (connId == parentId)) return false;
            return true;
        });
        if (newFields && newFields.length && newFields[0].name === aTypes.CONNECTOR) {
            newFields = newFields.slice(1, newFields.length);
        }
        this.setState({ targetFields: newFields });
    }

    onDateChange = ({ date, name }) => {
        const { userInputs } = this.state;
        this.setState({ userInputs: { ...userInputs, [name]: date } });
    }

    saveLastSearch = () => {
        this.props.updateFlexObjects({
            lastSearch: {
                targetFields: this.state.targetFields,
                userInputs: this.state.userInputs,
                advancedObj: this.state.advancedObj
            }
        });
    }

    onSearch = () => {
        const { targetFields, userInputs, advancedObj } = this.state;
        let fields = convertFields({ inFields: targetFields, userInputs, advancedObj });
        let advanced = { isProfi: true, fields };
        this.saveLastSearch();
        this.closeModal();
        this.props.searchClosed();
        let searchParams = {
            ...advanced,
            customCurrentSortOption: this.props.customCurrentSortOption
        };
        this.props.history.push({
            pathname: '/search', searchParams: searchParams,
            state: { search: JSON.stringify(searchParams) }
        });
    }

    onDiscardChanges = () => {
        this.setState(aTypes.SEARCH_INIT);
    }

    onLoad = () => { }


    onSaveBtn = () => {
        this.setState({ saveDlgOpened: true });
    }

    onItemGroup = ({ item }) => (e) => {
        if (e.shiftKey) {
            //if (e.ctrlKey) {
            // if (this.state.shiftArray && !this.state.shiftArray.length) {
            if (this.state.shiftArray) {
                if (!this.state.shiftArray.find(obj => obj.id == item.id)) {
                    let data = [...this.state.shiftArray, item];
                    let sortedData = null;
                    if (data && data.length > 1) {
                        sortedData = SortHelper.sortByValue({
                            data, sorted: aTypes.ASC, field: 'id', isNumber: true
                        });
                    }

                    this.setState({
                        shiftArray: sortedData ? sortedData : data,
                        shiftObj: { ...this.state.shiftObj, [`${item.id}`]: item }
                    });
                }
            }
        }
    }

    showSource = ({ item }) => {
        return (
            <div id={item.id} type='text'
                className='advanced-left-item' draggable='true' onDragStart={this.handleDragStart}
                onDragOver={this.handleDragOver} onDragEnter={this.handleDragEnter}
                onDragLeave={this.handleDragLeave} onDrop={this.handleDrop}
                onDragEnd={this.handleDragEnd} placeholder='Enter text here'
                value={this.state.sourceFields["testid"]} data-item={JSON.stringify(item.field)}>
                <span>{this.fm(item.intl)}</span>
            </div>
        );
    }

    showDynInput = ({ item }) => {
        return (
            <div className="advanced-input">
                <input id={item.id} type='text' className='input-item' placeholder={this.fm(item.intl)}
                    value={this.state.userInputs[`${uFi(item)}`]} disabled={true} />
                <div className="advanced-sm-btn" onClick={this.onInputBtnClick({ item })}>
                    <FontAwesomeIcon icon={faObjectGroup} />
                </div>
            </div>
        )
    }

    showTargetInput = ({ item, dyn, inNum = false }) => {
        if (dyn) return this.showDynInput({ item });
        return (
            <div className="advanced-input">
                <input id={item.id} type={inNum ? aTypes.NUMBER : 'text'}
                    className='input-item' onDragStart={this.handleDragStart}
                    onDragOver={this.handleDragOver} onDragEnter={this.handleDragEnter}
                    onDragLeave={this.handleDragLeave} onDrop={this.handleDrop}
                    onDragEnd={this.handleDragEnd} onChange={this.handleTargetInput({ item })}
                    placeholder={this.fm(item.intl)}
                    value={this.state.userInputs[`${uFi(item)}`]}
                />
            </div>);
    }

    showDDWithInput = ({ item, isConn, boxClasses, divClasses }) => {
        return (
            <div className={boxClasses}>
                <div className={divClasses}>
                    <DropdownWithInput data={item.data} showMax={5}
                        current={isConn ? this.state.advancedObj[`${item.id}`] : this.state.userInputs[`${uFi(item)}`]}
                        required={false} error={false}
                        onDDClick={this.onTargetDDCk({ item })} />
                </div>
            </div>
        );
    }

    showTargetDD = ({ item }) => {
        let boxClasses = "advanced-dd-box";
        let divClasses = "advanced-dd";
        let isConn = false;
        if (item.targetType == aTypes.CONNECTOR) {
            boxClasses = "advanced-conn-dd-box";
            divClasses = "advanced-conn-dd";
            isConn = true;
        }

        if (item && item.params && item.params.form_type === aTypes.FLEXLIST) {
            return this.showDDWithInput({ item, isConn, boxClasses, divClasses });
        }

        return (
            <div className={boxClasses}>
                <div className={divClasses}>
                    <Dropdown data={item.data}
                        //current={this.state.userInputs[`${uFi(item)}`]}
                        current={isConn ? this.state.advancedObj[`${item.id}`] : this.state.userInputs[`${uFi(item)}`]}
                        required={false} error={false}
                        onDDClick={this.onTargetDDCk({ item })} />
                </div>
            </div>
        );
    }

    showTargetType = ({ item }) => {
        let data = getSearchTypeData({ item });
        return (
            <div className="advanced-searchtype">
                <Dropdown data={data}
                    current={this.state.advancedObj[`${stype(item)}`]}
                    required={false} error={false}
                    onDDClick={this.onDDCk({ item })} />
            </div>
        );
    }

    showDeleteIcon = ({ item }) => {
        return (
            <div className="advanced-delete" onClick={this.onDeleteItem({ item })}>
                <FontAwesomeIcon icon={faPlus} />
            </div>
        )
    }


    showInputGroup = ({ item, isChild, dyn = false, inNum = false }) => {
        return (
            <div className="advanced-itembox" onClick={this.onItemGroup({ item })}>
                <div className="advanced-group">
                    <label className="advanced-label">
                        {this.props.intl.formatMessage({ id: item.intl })}
                    </label>
                    {this.showTargetType({ item })}
                    {this.showTargetInput({ item, dyn, inNum })}
                </div>
                {!isChild && this.showDeleteIcon({ item })}
            </div>
        )
    }


    showTargetDateBox = ({ item, isChild }) => {
        return (
            <CustomDateBox uiConfig={null} fMsgId={item.intl} label={null}
                mandatory={null} requiredField={null}
                name={item.name} selectedDate={this.state.userInputs[`${uFi(item)}`]}
                onChangeDate={(date) => this.onDateChange({ date, name: `${uFi(item)}` })} lg={this.props.lg}
                minDate={null} maxDate={null} datePos={`bottom-end`} hideLabel={true} />
        )
    }

    showDateGroup = ({ item, isChild }) => {
        return (
            <div className="advanced-itembox" onClick={this.onItemGroup({ item })}>
                <div className="advanced-date-group">
                    <label className="advanced-label">
                        {this.props.intl.formatMessage({ id: item.intl })}
                    </label>
                    {this.showTargetType({ item })}
                    {this.showTargetDateBox({ item, isChild })}
                </div>
                {!isChild && this.showDeleteIcon({ item })}
            </div>
        )

    }

    showDDGroup = ({ item, isChild }) => {
        return (
            <div className="advanced-itembox" onClick={this.onItemGroup({ item })}>
                <div className="advanced-group">
                    <label className="advanced-label">
                        {this.props.intl.formatMessage({ id: item.intl })}
                    </label>
                    {this.showTargetType({ item })}
                    {this.showTargetDD({ item })}
                </div>
                {!isChild && this.showDeleteIcon({ item })}
            </div>
        )
    }

    showTargetItem = ({ item, isChild = false }) => {
        switch (item.targetType) {
            case aTypes.INPUT:
            case aTypes.MASK:
                return this.showInputGroup({ item, isChild });
            case aTypes.INPUT_NUM:
                return this.showInputGroup({ item, isChild, inNum: true });
            case aTypes.DYN_TREE:
                return this.showInputGroup({ item, isChild, dyn: true });
            case aTypes.CONNECTOR:
                return this.showTargetDD({ item });
            case aTypes.DROPDOWN:
            case aTypes.MULTISELECT:
            case aTypes.USERLIST:
                return this.showDDGroup({ item, isChild });
            case aTypes.DATE_FROMTO:
                return this.showDateGroup({ item, isChild })
            default:
                return this.showInputGroup({ item, isChild });
        }
    }

    onHelpClick = () => {
        this.setState({ helpDlgOpened: !this.state.helpDlgOpened });
    }

    showTopActions = () => {
        return (
            <div className="advanced-top-actions">
                <Button onClick={this.onSaveBtn}>
                    <span className="advanced-top-actions-icon">
                        <FontAwesomeIcon icon={faSave} />
                    </span>
                    {this.props.intl.formatMessage({ id: "advanced.save" })}
                </Button>
                <span className="advanced-help-icon" onClick={this.onHelpClick}>
                    <FontAwesomeIcon icon={faQuestion} />
                </span>
            </div>
        )
    }

    showTypeFilter = () => {
        return (
            <TypeFilter
                hidden={!PH.showControl(this.props.uiConfig, Controls.CTL_TOOLBAR_MEDIATYPE_FILTER)}
                typeFilterLabel={this.props.intl.formatMessage({ id: "typeFilter.filetypes" })}
                key={this.props.uiConfig.language}
                toogleFilter={this.props.onToggleFilter}
                filter={this.props.filter} />
        )
    }

    showTop = () => {
        return (
            <div className="advanced-top">
                <div className="advanced-top-content">
                    <div className="advanced-heading">
                        <span>
                            <FontAwesomeIcon icon={faObjectGroup} />
                        </span>
                        {this.fm("advancedsearch.heading")}
                    </div>
                    <div className="advanced-content-middle">
                        <div>{this.showTypeFilter()}</div>
                        <div className="advanced-dd">
                            <Dropdown data={this.state.searchedList} current={this.state.searchedListCur}
                                required={false} error={false} isDeleted={true}
                                onDDClick={this.onDDSearchedList} onDDTrashClick={this.onDDSearchedListDelete} />
                        </div>
                        <Button onClick={this.onLoad} className="advanced-load">
                            {this.props.intl.formatMessage({ id: "advanced.load" })}
                        </Button>
                        <Button onClick={this.onEdit} btnOutline={true} className="advanced-update">
                            <span>
                                <FontAwesomeIcon icon={faEdit} />
                                <FontAwesomeIcon icon={faSave} />
                            </span>
                            {this.props.intl.formatMessage({ id: "advanced.edit" })}
                        </Button>
                        {this.showTopActions()}
                    </div>

                </div>
            </div>
        )
    }

    showDragDropInfo = () => {
        if (!this.state.targetFields || this.state.targetFields.length === 0) {
            return (
                <div className="advanced-choose-dragdrop">
                    <div>{this.fm("advanced.dragdrop.info")}</div>
                    <div><FontAwesomeIcon icon={faCloudDownloadAlt} /></div>
                </div>
            )
        }
    }

    getBoxClasses = () => {
        if (!this.state.targetFields || this.state.targetFields.length === 0) {
            return "advanced-drapdrop-box";
        }

        return "advanced-right-top";
    }

    showRightTop = () => {
        return (
            <div className={this.getBoxClasses()} id={"dragdropboxId"}
                onDragStart={this.handleDragStart} onDragOver={this.handleDragOver}
                onDragEnter={this.handleDragEnter} onDragLeave={this.handleDragLeave}
                onDrop={this.handleDrop} onDragEnd={this.handleDragEnd}>
                <div className="advanced-top-icon">
                    <FontAwesomeIcon icon={faObjectGroup} />
                </div>
                {this.state.targetFields.map(item => {
                    if (!item.data || item.targetType == aTypes.CONNECTOR || item.targetType === aTypes.USERLIST
                        || item.targetType == aTypes.DROPDOWN || item.targetType == aTypes.MULTISELECT) {
                        return this.showTargetItem({ item });
                    }
                    return (
                        <div className="advanced-parents">
                            <div>
                                {item.data.map(el => this.showTargetItem({ item: el, isChild: true }))}
                            </div>
                            <div className="advanced-delete" onClick={this.onDeleteItem({ item })}>
                                <FontAwesomeIcon icon={faPlus} />
                            </div>
                        </div>
                    )
                })}
                {this.showDragDropInfo()}
            </div>
        )
    }

    handleCb = (e) => {
        let sortOrder = aTypes.DESC;
        if (!this.state.advancedObj.sortOrder || this.state.advancedObj.sortOrder == aTypes.DESC) {
            sortOrder = aTypes.ASC;
        }
        this.setState({
            advancedObj: { ...this.state.advancedObj, sortOrder }
        })
    }

    onHelpForm = (el) => {
        this.setState({ helpCur: el });
    }

    showSortingBox = () => {
        let isChecked = true;
        if (this.state.advancedObj[aTypes.SORT_OBJ.sortOrder]
            && this.state.advancedObj[aTypes.SORT_OBJ.sortOrder] == aTypes.ASC) {
            isChecked = false;
        }
        return (
            <>
                <div className="advanced-dd-box">
                    <label>{this.props.intl.formatMessage({ id: aTypes.SORT_OBJ.intl })}</label>
                    <div className="advanced-dd">
                        <Dropdown data={aTypes.SORT_OBJ.data}
                            current={this.state.advancedObj[aTypes.SORT_OBJ.name]}
                            required={false} error={false}
                            onDDClick={this.onSortDDCk({ item: aTypes.SORT_OBJ })} />
                    </div>
                </div>
                <div>
                    <CheckBox onCbHandler={this.handleCb} isChecked={isChecked}
                        label={this.props.intl.formatMessage({ id: "advanced.desc" })} />
                </div>
            </>)
    }

    showRightContent = () => {
        return (
            <div className="advanced-right">
                {this.showRightTop()}
                <div className="advanced-right-bottom">
                    <div className="advanced-bottom-box">
                        <div className="advanced-bottom-gr">
                            {/* {this.showSortingBox()} */}
                        </div>
                        <div className="advanced-search-btn-group">
                            {aTypes.SEARCH_BTN_GROUP.map(item => (
                                <Button onClick={this[item.onClick]} btnOutline={item.outline}
                                    className="advanced-search">
                                    <span><FontAwesomeIcon icon={item.icon} /></span>
                                    {this.fm(item.intl)}
                                </Button>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    showSearchForm = () => {
        let currentTab;
        return (
            <div className="AdvancedSearch">
                <div className="advanced-container">
                    {this.showTop()}
                    <div className="advanced-content">
                        <div className="advanced-left">
                            {this.state.sourceFields.map(item => {
                                if (item.tab !== currentTab) {
                                    currentTab = item.tab;
                                    return (<>
                                        <div className="advanced-tab">{this.fm(item.tab)}</div>
                                        {this.showSource({ item })}
                                    </>)
                                }
                                return this.showSource({ item })
                            })}
                        </div>
                        {this.showRightContent()}
                    </div>
                </div>
            </div>)
    }

    // SAVE_DIALOG BEGIN
    showSaveDialog = () => {
        return (
            <div className="advanced-save-form">
                {aTypes.SAVEDLG_ITEMS.map((el, idx) => {
                    return (
                        <FormInput name={el.name} key={`advanced_input_${idx}`} type={el.type}
                            value={this.state.userInputs[`${el.name}`] || ""} readOnly={el.readOnly}
                            error={this.state.errors[`${el.name}`]} placeholder={this.fm(el.intl)}
                            onChange={(e) => this.onSaveDlgInput(e, el.name)} required={el.required} />
                    )
                })}
                <Button onClick={this.onSaveDlg}>
                    {this.fm("advanced.save")}
                </Button>
            </div>
        )
    }

    getMWFields = () => {
        let fields = [];
        fields = this.state.targetFields.map(entry => {
            //if (entry.name == aTypes.CONNECT) return null;
            if (entry.name == aTypes.CONNECTOR) return null;
            return {
                field: entry.field,
                type: this.state.advancedObj[entry.field] || '=',
                value: this.state.userInputs[entry.field] || ''
            }
        }).filter(entry => entry);
        return fields;
    }

    saveListData = ({ list }) => {
        //console.log("LOGS: saveListData list", list);
        this.props.updateFlexObjects({ searchedList: list });
        this.props.saveUserSearchData({
            user: { id: this.props.user.id, groupid: this.props.user.groupid },
            option: aTypes.ADVANCED_PRE, data: list,
            formatMessage: this.props.intl.formatMessage
        });
    }

    onSaveDlg = () => {
        let list = [];
        const { searchedList } = this.props.flexObjects;
        if (this.state.userInputs && this.state.userInputs.savedSearch) {
            let name = this.state.userInputs.savedSearch;
            if (name) {
                let newItem = {
                    name, intl: name, value: `savedItem_${Date.now()}`,
                    data: this.state.targetFields, userInputs: { ...this.state.userInputs },
                    advancedObj: { ...this.state.advancedObj }
                };
                if (searchedList) list = [...searchedList, newItem];
                else list.push(newItem);
                this.saveListData({ list });
                this.setState({
                    searchedListCur: { ...newItem },
                    saveDlgOpened: false,
                    userInputs: { ...this.state.userInputs, savedSearch: '' }
                });
            }
        }
    }

    onEdit = () => {
        let list = [];
        const { searchedList } = this.props.flexObjects;
        if (this.state.userInputs && this.state.searchedListCur && searchedList) {
            let found = searchedList.find(item => item.value == this.state.searchedListCur.value);
            let newItem;
            if (found) {
                newItem = {
                    ...found, data: this.state.targetFields,
                    userInputs: { ...this.state.userInputs },
                    advancedObj: { ...this.state.advancedObj }
                };
                let index = searchedList.findIndex(item => item.value == this.state.searchedListCur.value);
                list = [...searchedList];
                list[index] = newItem;
                this.saveListData({ list });
            }
        }
    }

    onDlgSave = () => {
        this.setState({ saveDlgOpened: false });
    }

    onSaveDlgInput = (e, name) => {
        this.setState({ userInputs: { ...this.state.userInputs, [name]: e.target.value } });
    }

    onHelpDlgInput = (e, name) => {
        this.setState({ userInputs: { ...this.state.userInputs, [name]: e.target.value } });
    }

    onCloseMsgDlg = () => {
        if (this.state.saveDlgOpened) this.setState({ saveDlgOpened: false });
        if (this.state.helpDlgOpened) this.setState({ helpDlgOpened: false });
    }
    //SAVE_DIALOG END

    componentDidUpdate(prev) {
        if (prev.flexObjects.searchedList != this.props.flexObjects.searchedList) {
            this.updateData();
        }

        if (prev.flexObjects.flexTags != this.props.flexObjects.flexTags) {
            this.initData();
        }

        if (prev.isOpened != this.props.isOpened) {
            this.setState({ modalOpened: this.props.isOpened });
        }
    }

    componentDidMount() {
        this.setState({ modalOpened: true });
        this.checkWindowKey();
        this.initData();
    }

    componentWillUnmount() {
        this.removeWindowKey();
    }

    render() {
        return (
            <div className="AdvancedSearch">
                <Modal className="advanced-modal" open={this.state.modalOpened}
                    onClose={() => this.setState({ modalOpened: false })}>
                    <div className="advanced-close" onClick={this.closeModal}>
                        <FontAwesomeIcon icon={faPlus} />
                    </div>
                    {this.showSearchForm()}
                    {this.state.helpDlgOpened && <HelpDialog isOpened={this.state.helpDlgOpened} onClose={this.onCloseMsgDlg} />}
                    {(this.state.saveDlgOpened) && (
                        <MsgDialog isSaveDlg={true} text={'MsgDialog'} open={this.state.saveDlgOpened}
                            handleMsgDialog={() => { }}>
                            {this.state.saveDlgOpened && this.showSaveDialog()}
                            <div className="advanced-close" onClick={this.onCloseMsgDlg}>
                                <FontAwesomeIcon icon={faPlus} />
                            </div>
                        </MsgDialog>
                    )}
                    {this.state.stockOpened && (
                        <StockWindow
                            {...this.props} show={this.state.stockOpened}
                            onSelect={(tags = [], keywords = []) => { }}
                            onClose={() => this.setState({ stockOpened: false })}
                            selected={[]} keywords={[]} onLoaded={(tags = [], keywords = []) => { }}
                            singleSelect={true}
                            changeHandler={this.onStockHandler}
                        />
                    )}
                </Modal>
            </div>
        );
    }
}

const mapStateToprops = (state) => ({
    flexObjects: state.flex.flexObjects,
    showExpertSearch: state.ui.expertSearchState,
    config: state.metadata.config,
    user: state.auth.user,
    users: state.user.users,
    lg: state.ui.language,
    uiConfig: state.ui.config,
    filter: state.ui.filter,
})
const mapDispatchToProps = (dispatch) => ({
    updateFlexObjects: (obj) => dispatch(actions.updateFlexObjects(obj)),
    searchClosed: () => dispatch(actions.expertSearchClosed()),
    saveUserSearchData: (obj) => dispatch(actions.saveUserSearchData(obj)),
    searchProfi: (obj) => dispatch(actions.searchProfi(obj)),
    searchClosed: () => dispatch(actions.expertSearchClosed()),
    getFlexTags: () => dispatch(actions.getFlexTags()),
    onToggleFilter: (filter) => dispatch(actions.toggleFilter(filter)),
})

export default connect(mapStateToprops, mapDispatchToProps)(injectIntl(withRouter(AdvancedSearch)));
